var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parent-formula-input"},[_c('div',{staticClass:"formula-input",attrs:{"contenteditable":"true","spellcheck":"false"},domProps:{"innerHTML":_vm._s(_vm.inputValue)},on:{"keydown":_vm.keydownEvent,"keyup":_vm.keyupEvent,"click":_vm.clickEvent,"blur":_vm.blurEvent}})])
}
var staticRenderFns = []

export { render, staticRenderFns }